import { getUniversalPageProps } from 'src/utils/getters/getUniversalPageProps';
export { WiredMigrateToZillow as default } from 'src/experiences/MigrateToZillow';
export const getServerSideProps = getUniversalPageProps();
